import { ICard } from 'pages/fbmanager/model/types/card';

export enum CardsActionTypes {
  SET_CARDS = 'SET_CARDS',
  UPDATE_CARDS = 'UPDATE_CARDS',
  REMOVE_CARDS = 'REMOVE_CARDS',
  SET_CARD_NUMBER = 'SET_CARD_NUMBER',
  SET_CARD_EXPIRY_DATE = 'SET_CARD_EXPIRY_DATE',
  SET_CARD_CVC = 'SET_CARD_CVC',
  CLEAR_CARDS = 'CLEAR_CARDS',
}

interface ISetCardsAction {
  type: CardsActionTypes.SET_CARDS;
  payload: string[];
}

interface IUpdateCardsAction {
  type: CardsActionTypes.UPDATE_CARDS;
  payload: ICard;
}

interface IRemoveCardsAction {
  type: CardsActionTypes.REMOVE_CARDS;
  payload: string;
}

interface ISetCardNumberAction {
  type: CardsActionTypes.SET_CARD_NUMBER;
  payload: string;
}

interface ISetCardExpiryDateAction {
  type: CardsActionTypes.SET_CARD_EXPIRY_DATE;
  payload: string;
}

interface ISetCardCvcAction {
  type: CardsActionTypes.SET_CARD_CVC;
  payload: string;
}

interface IClearCardsAction {
  type: CardsActionTypes.CLEAR_CARDS;
}

export type TCardsActions =
  | ISetCardsAction
  | IRemoveCardsAction
  | IUpdateCardsAction
  | ISetCardNumberAction
  | ISetCardExpiryDateAction
  | ISetCardCvcAction
  | IClearCardsAction;

export const setCardsAction = (payload: string[]): TCardsActions => ({
  type: CardsActionTypes.SET_CARDS,
  payload,
});

export const updateCardAction = (payload: ICard): TCardsActions => ({
  type: CardsActionTypes.UPDATE_CARDS,
  payload,
});

export const removeCardsAction = (payload: string): TCardsActions => ({
  type: CardsActionTypes.REMOVE_CARDS,
  payload,
});

export const setCardNumberAction = (payload: string): TCardsActions => ({
  type: CardsActionTypes.SET_CARD_NUMBER,
  payload,
});

export const setCardExpiryDateAction = (payload: string): TCardsActions => ({
  type: CardsActionTypes.SET_CARD_EXPIRY_DATE,
  payload,
});

export const setCardCvcAction = (payload: string): TCardsActions => ({
  type: CardsActionTypes.SET_CARD_CVC,
  payload,
});

export const clearCardsAction = (): TCardsActions => ({
  type: CardsActionTypes.CLEAR_CARDS,
});
